import React, { useEffect, useState } from "react";
import { MapRevisedProps as MapProps } from "shared-component/geofilter4";
import LatLongModalComponent from "./lat-long-component";
import MapComponentRevised from "shared-component/geofilter4";

const Geofence = (props: any) => {
  const { updateCoordinates, updateBond } = props;
  const [coordinates, setCoordinates] = useState<
    Array<[number | null, number | null]>
  >([
    [null, null],
    [null, null],
    [null, null],
    [null, null],
  ]);
  const [showPanel, setShowPanel] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>("in_bond");
  const checkCoordinates = (coordinates: Array<[number | null, number | null]>, props: any) => {
    const isAnyEmptyOrNull = coordinates.some(
      ([lat, lng]) => lat === null || lng === null || isNaN(lat) || isNaN(lng)
    ) || coordinates.every(([lat, lng]) => lat === null && lng === null);

    const isAnyFilled = coordinates.some(
      ([lat, lng]) => lat !== null || lng !== null
    );

    const isAllFilled = coordinates.every(
      ([lat, lng]) => lat !== null && lng !== null
    );

    if (isAllFilled) {
      props.onChangeLatLang(false);
    } else {
      props.onChangeLatLang(!(isAnyEmptyOrNull && !isAnyFilled) && (!isAllFilled || isAnyFilled));
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const newCoordinates = [...coordinates];
    const { value } = event.target as HTMLInputElement;
    const coordinateIndex = Math.floor(index / 2);
    const coordinatePosition = index % 2;

    newCoordinates[coordinateIndex][coordinatePosition] =
      value === "" ? null : parseFloat(value);
    setCoordinates(newCoordinates);
    checkCoordinates(newCoordinates, props);
  };

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event?.target?.value);
  };

  const handleSVGClick = (points: [number, number], index: number) => {
    const newCoordinates = [...coordinates];
    newCoordinates[index] = points;
    setCoordinates(newCoordinates);

    checkCoordinates(newCoordinates, props);
  };

  const handleClearCoordinates = () => {
    const resetCoordinates: Array<[number | null, number | null]> = [
      [null, null],
      [null, null],
      [null, null],
      [null, null],
    ];
    setCoordinates(resetCoordinates);
    checkCoordinates(resetCoordinates, props);
  };

  const points = coordinates.map(([latitude, longitude]) => ({
    latitude: latitude === null ? NaN : latitude,
    longitude: longitude === null ? NaN : longitude,
  }));

  const mapProps: MapProps = {
    points,
    onCoordinateChange: handleSVGClick,
    mapPosition: props?.mapDataPoints,
    coordinatePanel: setShowPanel,
    showPanel: showPanel,
    selectionOption: selectedOption,
    setSelectedOption: setSelectedOption,
    filterData: props?.filtersData,
    mapData: props?.mapData,
    showRangeButtons: props?.showRangeButtons,
    showLatLongEntry: props?.showLatLongEntry, 
    allowMarkerCreation: props?.allowMarkerCreation,
  };

  useEffect(() => {
    updateCoordinates(coordinates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordinates]);

  useEffect(() => {
    updateBond(selectedOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  return (
    <div>
      <LatLongModalComponent modalOpen={showPanel} setModalOpen={setShowPanel}  coordinates={coordinates} handleInputChange={handleInputChange} selectedOption={selectedOption} handleOptionChange={handleOptionChange} handleClearCoordinates={handleClearCoordinates} />
      <MapComponentRevised {...mapProps} />
    </div>
  );
};

export default Geofence;
